import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import Griddle, {plugins, RowDefinition, ColumnDefinition} from 'griddle-react'
import Text from 'react-text'
import {enhancedWithRowData} from '../../helpers/utils'
import {Consumer} from '../../context'

const Layout = ({Table}) => (<div><Table /></div>)

const EmptyHeader = () => (<span />)

const groupName = ({subject, grade, name}) => `${subject} ${grade} ${name}`

const StudentsColumn = enhancedWithRowData(props => {
  const {students} = props.rowData
  return (<span title={students.map(({name}) => name).join("\n")}>{students.length}</span>)
})

export default function DashboardGroups (props) {
  return (<Consumer>{ context => {
      const {groups, link, locked} = context

      const GroupLink = enhancedWithRowData(({rowData}) => (
        <Link
          className="group-link"
          title={rowData.name}
          to={locked ? '#' : link({course: rowData.course}, '/:languageId/:role/my-courses/:course')}
        >
          {rowData.name}
        </Link>)
      )

      return (
        <Griddle
          data={groups}
          components={{Layout}}
        >
         <RowDefinition>
           <ColumnDefinition
             id='name'
             customHeadingComponent={EmptyHeader}
             customComponent={GroupLink}
           />
           <ColumnDefinition
             id='students'
             customHeadingComponent={EmptyHeader}
             customComponent={StudentsColumn}
           />
         </RowDefinition>
        </Griddle>
      )
    }}</Consumer>)
}
